import React, { useEffect, useState } from 'react';
import axios from 'axios';

const API = process.env.REACT_APP_BACKEND_URL;

export default function Dashboard() {
  const [stats, setStats] = useState({ appointments: 0, treatments: 0, team: 0 });
  const [recent, setRecent] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [{ data: s }, { data: r }] = await Promise.all([
          axios.get(`${API}/api/admin/stats`, { withCredentials: true }),
          axios.get(`${API}/api/admin/appointments`, { withCredentials: true })
        ]);
        setStats(s);
        setRecent(r.slice(0, 5));
      } catch (err) {
        console.error(err);
      }
    };
    fetchData();
  }, []);

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-slate-900">Dashboard</h1>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
          <h3 className="text-sm font-medium text-slate-500 mb-2">Toplam Randevu</h3>
          <p className="text-3xl font-bold text-primary">{stats.appointments}</p>
        </div>
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
          <h3 className="text-sm font-medium text-slate-500 mb-2">Tedaviler</h3>
          <p className="text-3xl font-bold text-primary">{stats.treatments}</p>
        </div>
        <div className="bg-white p-6 rounded-2xl shadow-sm border border-slate-200">
          <h3 className="text-sm font-medium text-slate-500 mb-2">Hekimler</h3>
          <p className="text-3xl font-bold text-primary">{stats.team}</p>
        </div>
      </div>

      <div className="bg-white rounded-2xl shadow-sm border border-slate-200 overflow-hidden">
        <div className="p-6 border-b border-slate-100">
          <h3 className="text-lg font-bold text-slate-900">Son Randevular</h3>
        </div>
        <table className="w-full text-left text-sm text-slate-600">
          <thead className="bg-slate-50 border-b border-slate-100 text-slate-500">
            <tr>
              <th className="px-6 py-3 font-medium">Hasta Adı</th>
              <th className="px-6 py-3 font-medium">Telefon</th>
              <th className="px-6 py-3 font-medium">Tarih</th>
              <th className="px-6 py-3 font-medium">Tedavi</th>
              <th className="px-6 py-3 font-medium">Durum</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-slate-100">
            {recent.map((apt) => (
              <tr key={apt.id} className="hover:bg-slate-50/50">
                <td className="px-6 py-4 font-medium text-slate-900">{apt.name}</td>
                <td className="px-6 py-4">{apt.phone}</td>
                <td className="px-6 py-4">{apt.date}</td>
                <td className="px-6 py-4">{apt.treatment}</td>
                <td className="px-6 py-4">
                  <span className={`px-2.5 py-1 rounded-full text-xs font-medium ${
                    apt.status === 'Pending' ? 'bg-yellow-100 text-yellow-800' :
                    apt.status === 'Approved' ? 'bg-green-100 text-green-800' :
                    'bg-slate-100 text-slate-800'
                  }`}>
                    {apt.status}
                  </span>
                </td>
              </tr>
            ))}
            {recent.length === 0 && (
              <tr>
                <td colSpan="5" className="px-6 py-8 text-center text-slate-500">Kayıt bulunamadı.</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
}
